module.exports = __webpack_public_path__ + "static/img/14001001.486e5df7.png";